var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.componentClasses},_vm.$listeners),[_c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"4.5","stroke":"#FFBA00","stroke-width":"3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }